import request from './interceptor'

// 补发记录提交
export function reissueDelivery(data) {
  return request({
    url: '/v1/finances/reissue-delivery',
    method: 'post',
    data
  })
}
